export enum DropdownPanelKind {
    Menu = 'Menu',
    Select = 'Select',
    Chips = 'Chips'
}

export enum DropdownPanelItemKind {
    Item = 'Item',
    Group = 'Group',
    Divider = 'Divider'
}